import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import queryString from 'query-string';
import { fetchAuthSession as amplifyFetchAuthSession } from 'aws-amplify/auth';
import { API_HOST } from '../../apiUrls';
import { AMPLIFY_ERROR_CODE } from '../../utils/cognitoErrorUtils';


// initialize an empty api service that we'll inject endpoints into later as needed
export const cabinetApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_HOST}/`,
    prepareHeaders: async (headers, api) => {
      const newHeaders = await makeHeaders(true);
      if (newHeaders) {
        // we don't want to explicitly set the Content-Type. It will default to JSON, but in cases
        // where form data is given it will automatically change to multipart/form-data
        delete newHeaders['Content-Type'];
        Object.entries(newHeaders).forEach(([name, val]) => {
          headers.append(name, val);
        });
      }

      return headers;
    },
    paramsSerializer: (params: Record<string, unknown>) => (
      queryString.stringify(params, { arrayFormat: 'none' })
    ),
    // fetchFn: async (request, ...args) => {
    //   if (request instanceof Request) {
    //     if (!request.headers.has('Authorization') && !request.headers.has('x-skip-logout')) {
    //       throw new Error('MissingAuthorizationHeader');
    //     }
    //     request.headers.delete('x-skip-logout');
    //   }
    //   return fetch(request, ...args);
    // }
  }),
  endpoints: () => ({}),
});

  
interface FetchContent {
  headers?: { [key: string]: string };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any;
  method?: string;
}

export const makeAuthHeader = (token?: string | null): string => {
  return `bearer ${token}`;
};

export const makeHeaders = async (shouldAuthenticate?: boolean): Promise<FetchContent['headers']> => {
  const headers: { [key: string]: string } = {
    'Content-Type': 'application/json',
    'Pragma': 'no-cache',
    'FrontendVersion': import.meta.env.VITE_APP_FRONTEND_VERSION || '',
    'AppName': "app"
  };

  if (shouldAuthenticate) {
    try {
      const session = await amplifyFetchAuthSession();
      const token = session.tokens?.idToken?.toString() || null;
      if (token) {
        headers['Authorization'] = makeAuthHeader(token);
      }
    } catch (err) {
      // err can sometimes be a string or an Error object. Difficult to determine which until here.
      if (err instanceof Error && "code" in err && err['code'] !== AMPLIFY_ERROR_CODE.NETWORK_ERROR) {
        console.error(err);
      } else {
        headers['x-skip-logout'] = 'true';
      }
    }
  }

  return headers;
};
